console.log('service.js');
self.addEventListener('push', (event) => {
  console.log('service.js > push',event.data.text());
  self.registration.showNotification(event.data.text())
})
